module.exports = __webpack_public_path__ + "static/media/Atomo_desk.cb58f769.png";